module.exports = __webpack_public_path__ + "img/79.9c529f64.jpg";